import React from 'react';
import './Spinner.css';

/*
    Spinner genérico para indicar carga de datos en listados.
*/
function Spinner({ texto = 'Cargando...' }) {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
      {texto && <span className="spinner-texto">{texto}</span>}
    </div>
  );
}

export default Spinner;
